export default __webpack_public_path__ + "static/callout-4578e847abdc2ac7a30e5bcdd650134d.webp";